import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=6d35f9d1&"
import script from "./Partner.vue?vue&type=script&lang=js&"
export * from "./Partner.vue?vue&type=script&lang=js&"
import style0 from "./Partner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports